import React from 'react';
import { Box, Stack, Typography, colors } from '@mui/material';
import { currencyUtils } from 'skipify-types';

import { formatCurrency } from '../../../../util/formatters';
import {
  PartialPaymentSummaryPill,
  PartialPaymentSummaryAmounts,
} from './PartialPaymentSummaryPill';

type Props = {
  partialPayment: PartialPaymentSummaryAmounts | null;
  displayAmount: string;
  approvedAmount: number | null;
  orderTotal: number;
  currencyCode?: string;
  size?: 'small' | 'medium';
};

export const PaylinkSummaryAmountSection = ({
  partialPayment,
  displayAmount,
  approvedAmount,
  orderTotal,
  currencyCode,
  size = 'medium',
}: Props): JSX.Element => {
  if (partialPayment) {
    return (
      <Box
        sx={{
          width: '100%',
          mt: 1,
          display: 'flex',
          alignItems: 'stretch',
          borderRadius: '14px',
          overflow: 'hidden',
          backgroundColor: colors.common.white,
          border: `1px solid ${colors.grey[300]}`,
          boxShadow: '0 1px 4px rgba(16, 24, 40, 0.06)',
        }}
      >
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            flex: '0 0 36%',
            py: 1,
            px: 1,
            borderRight: `1px solid ${colors.grey[200]}`,
          }}
        >
          <Typography
            sx={{
              fontSize: 10,
              fontWeight: 600,
              color: 'grey.600',
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
              lineHeight: 1.2,
            }}
          >
            Paylink total
          </Typography>
          <Typography
            sx={{
              fontSize: 26,
              lineHeight: 1.15,
              fontWeight: 700,
              color: 'grey.900',
              mt: 0.25,
            }}
          >
            {displayAmount}
          </Typography>
        </Stack>
        <Box sx={{ flex: 1, minWidth: 0, py: 1, px: 1.25 }}>
          <PartialPaymentSummaryPill {...partialPayment} currencyCode={currencyCode} embedded />
        </Box>
      </Box>
    );
  }

  return (
    <>
      <Typography
        sx={{
          fontSize: 32,
          lineHeight: '36px',
          fontWeight: 600,
          color: colors.common.black,
          marginTop: size === 'small' ? 0.5 : 1,
        }}
      >
        {displayAmount}
      </Typography>
      {!!approvedAmount && approvedAmount !== orderTotal && (
        <Typography
          sx={{
            fontSize: '12px',
            lineHeight: '16px',
            fontWeight: 400,
            color: 'grey.800',
            marginTop: size === 'small' ? 0.5 : 1,
          }}
        >
          {formatCurrency(currencyUtils.minorToMajor(orderTotal), currencyCode)} Total
        </Typography>
      )}
    </>
  );
};
